export function cachedStreamingAssistantMatchesSnapshotMessage(cachedAssistant: any, snapshotMessage: any): boolean {
  if (!cachedAssistant || !snapshotMessage) return false;
  if (snapshotMessage.role !== 'assistant') return false;
  if (cachedAssistant.clientMessageId && snapshotMessage.clientMessageId) {
    return cachedAssistant.clientMessageId === snapshotMessage.clientMessageId;
  }
  const cachedStart = String(cachedAssistant.firstResponseAt || cachedAssistant.timestamp || '').trim();
  const snapshotStart = String(snapshotMessage.firstResponseAt || snapshotMessage.timestamp || '').trim();
  if (!cachedStart || !snapshotStart || cachedStart !== snapshotStart) return false;
  const cachedText = String(cachedAssistant.content || '').trim();
  const snapshotText = String(snapshotMessage.content || '').trim();
  if (!cachedText || !snapshotText) return false;
  return cachedText === snapshotText
    || cachedText.startsWith(snapshotText)
    || snapshotText.startsWith(cachedText);
}
